<!--AdminLayout.vue-->
<template>
  <div class="admin-layout">
    <!-- 只有在側邊欄「尚未展開」時才顯示漢堡按鈕 -->
    <button
      v-if="!isSidebarOpen"
      @click="toggleSidebar"
      class="menu-toggle-btn"
    >
      ☰
    </button>

    <!-- 側邊欄 -->
    <AdminSidebar
      :is-sidebar-open="isSidebarOpen"
      @closeSidebar="toggleSidebar"
    />

    <!-- 透明灰色遮罩 -->  
    <!-- 只有在手機版 + 側邊欄展開時才顯示，點擊可關閉 -->
    <div
      v-if="isSidebarOpen"
      class="mobile-overlay"
      @click="toggleSidebar"
    ></div>

    <!-- 主要內容 -->
    <div class="admin-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import AdminSidebar from '@/components/__AdminSidebar.vue'

export default {
  name: 'AdminLayout',
  components: {
    AdminSidebar
  },
  setup() {
    // 用於控制手機版時，側邊欄是否顯示
    const isSidebarOpen = ref(false)

    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value
    }

    return {
      isSidebarOpen,
      toggleSidebar
    }
  }
}
</script>

<style scoped>

/* 整體布局 */
.admin-layout {
  margin: 0;
  padding: 0;
  display: flex;         /* 預設側邊欄 + 內容並排 */
  min-height: 100vh;     /* 讓畫面至少鋪滿視窗高度 */
}

/* 漢堡按鈕 (手機版) */
.menu-toggle-btn {
  display: none;    
  position: fixed; /* 固定於瀏覽器視窗 */
  z-index: 1002;
  background: #2E3A59;
  color: #fff;
  font-size: 1.5rem;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

/* 主要內容 */
.admin-content {
  flex: 1;
  background-color: #fafafa;
  padding: 1rem;
  box-sizing: border-box;
}

/* 手機版的灰色透明遮罩 */
.mobile-overlay {
  display: none;         /* 桌面版隱藏，手機版才要顯示 */
}

/* 手機版才顯示漢堡按鈕與遮罩 */
@media (max-width: 1425px) {
  .menu-toggle-btn {
    display: block;
  }
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;    /* 讓遮罩貼滿畫面可視寬度，不要多出滾動條 */
    height: 100%;   /* 若想要蓋全畫面，可以用 position: fixed; top: 0; left: 0; bottom: 0; right: 0; */
    background: rgba(0,0,0,0.5);
    z-index: 1000;       /* 剛好在 Sidebar 下方，但在內容上方 */
  }
  
}
</style>
